<h1 mat-dialog-title>
	<span i18n *ngIf="dialogData.type !== termType.app">Add another language or new version</span>
	<span i18n *ngIf="dialogData.type === termType.app">Add new version</span>
</h1>

<span
	class="badge badge-pill badge-secondary deploy-badge px-3 py-1"
	*ngIf="dialogData?.cluster"
>{{dialogData?.cluster?.name}} ({{dialogData?.cluster?.clusterId}})</span>

<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row">
			<mat-form-field appearance="standard" class="col-4" *ngIf="dialogData.type !== termType.app">
				<mat-label i18n>Language</mat-label>
				<mat-select formControlName="locale" >
					<mat-option *ngFor="let option of locales" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-4 legal-new__version">
				<mat-label i18n>Version</mat-label>
				<input matInput [type]="dialogData.type === termType.app ? 'text' : 'number'" placeholder="1.0" step="0.1" formControlName="version" />
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-4 legal-new__status">
				<mat-label i18n>Status</mat-label>
				<mat-select formControlName="active" >
					<mat-option id="{{option.value}}" *ngFor="let option of statuses" [value]="option.value">{{ option.label }}</mat-option>
				</mat-select>
			</mat-form-field>

			<div class="col-12" *ngIf="getVersionError()">
				<div class="alert alert-danger version-alert-panel">{{ getVersionError() }}</div>
			</div>

			<mat-form-field appearance="standard" class="col-12" *ngIf="dialogData.type !== termType.app">
				<mat-label i18n>Document name</mat-label>
				<input matInput type="text" placeholder="Terms and Conditions" i18n-placeholder formControlName="name" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.name"
					[type]="formEditorInputType.text"
				></mat-error>
			</mat-form-field>

			<div class="col-12 mb-2 legal-new__type" *ngIf="dialogData.type === termType.app">
				<label class="d-block">Provide document via:</label>
				<mat-radio-group formControlName="fileType">
					<mat-radio-button id="{{fileTypes.url}}" class="ml-3" [value]="fileTypes.url">File URL</mat-radio-button>
				</mat-radio-group>
			</div>

			<mat-form-field appearance="standard" class="col-12 legal-new__url">
				<mat-label i18n>URL</mat-label>
				<input matInput type="url" placeholder="URL" i18n-placeholder formControlName="url" />
				<mat-error
					appFormErrorMessage
					[errorFormControl]="formInputs.controls.url"
					[type]="formEditorInputType.url"
				></mat-error>
			</mat-form-field>
		</div>

		<div
			class="alert alert-dark alert-panel-text mt-4 mb-0"
			i18n
			*ngIf="dialogData.type !== termType.app"
		>
			Leave the version the same when adding support for an additional language. Incrementing the version number will archive all previous editions, no matter what language.
		</div>
	</div>

	<div mat-dialog-actions class="row justify-content-md-center mb-0">
		<div class="col-6 text-center">
			<button class="w-100" mat-flat-button mat-dialog-close (click)="cancel()" i18n>Cancel</button>
		</div>
		<div class="col-6 text-center">
			<button mat-flat-button color="primary" class="w-100" [disabled]="!formIsValid" type="submit" i18n>Ok</button>
		</div>
	</div>
</form>
